import React, { FC } from 'react'

import { Box } from '@mui/material'
import { useTranslation } from 'react-i18next'

import {
  EmptyData,
  Indicators,
  ReportWidgetsHeader,
  StyledWidgetWrapper,
} from '../../pages/Reports'
import { HorizontalMultiBar } from '../HorizontalMultiBar'

import { LevelOfStressWidgetProps } from './types'

export const LevelOfStressWidget: FC<LevelOfStressWidgetProps> = ({
  title,
  explanation,
  data,
  minZone,
  maxZone,
}) => {
  const { t } = useTranslation()
  const emptyData = (
    <EmptyData
      title={t('notEnoughData', 'Not enough data')}
      subtitle={t('pleaseCompleteJournalingSection', 'Please complete "Journaling" section')}
    />
  )

  return (
    <StyledWidgetWrapper>
      <ReportWidgetsHeader text={title} explanation={explanation}>
        <Indicators
          positiveLabel={t('low', 'Low')}
          negativeLabel={t('high', 'High')}
          middleLabel={t('mid', 'Mid') as string}
        />
      </ReportWidgetsHeader>

      <Box mt={4}>
        {!data.length ? (
          emptyData
        ) : (
          <HorizontalMultiBar
            data={data}
            maxZonePresents={maxZone}
            minZonePresents={minZone}
            percentType
          />
        )}
      </Box>
    </StyledWidgetWrapper>
  )
}
